import { FC, useContext, useMemo } from "react";
import appStyles from "../../../App.module.css";
import PaymentIcons from "../../../amt/components/common/PaymentIcons";
import { formatAmount } from "../../../app-constants";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortuguesePurchasePathContext, PackageKey } from "../../config/interface";
import { getDocumentsForPackage, portugueseUrlAndDocs } from "../../config/portuguese-Constant";
import NextButton from "../buttons/NextButton";
import PPPackageDisplayName from "../page/PPPPackageDisplayName";

interface PPQuoteSummaryProps {
  pay: boolean;
  quoteClass?: string;
}

const PPQuoteSummary: FC<PPQuoteSummaryProps> = (props: PPQuoteSummaryProps) => {
  const { pay, quoteClass } = props;
  const { quoteData, quoteResult, next } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;

  const isDocsAvailable = useMemo(() => {
    const affiliateId = Number(quoteData?.affiliate_id);
    const packageAlias = quoteData?.packages.alias as PackageKey;
    const url = getDocumentsForPackage(affiliateId, packageAlias);
    return url;
  }, [quoteData?.packages?.alias]);

  return (
    <div className={`${appStyles.quoteTotalBoxOuter} ${quoteClass}`}>
      <div className={`${appStyles.borderBox} ${appStyles.quoteTotalBox}`}>
        <div className={`${appStyles.textCenter} ${appStyles.quoteSummaryWrapper}`}>
          <h4 className={`${appStyles.mB20}`}>Get your Trips Insured for</h4>

          <div className={`${appStyles.ppPackageDetail}`}>
            <PPPackageDisplayName packageName={quoteResult?.details[0]?.type} />
            <div>{formatAmount(quoteResult?.details[0]?.amount || 0, "US", quoteData?.currency?.value || "EUR")}</div>
          </div>
          <div className={`${appStyles.ppPackageDetail}`}>
            Tax
            <div>{formatAmount(quoteResult?.taxes?.tax || 0, "US", quoteData?.currency?.value || "EUR")}</div>
          </div>
          <hr className={`${appStyles.ppHrStyle}`} />

          <div className={`${appStyles.ppPackageDetail}`}>
            <div>
              <b>
                Total<small className={appStyles.priceText}>(inc. tax)</small>
              </b>
            </div>

            <b>
              <div>{formatAmount(quoteResult?.quoted_price || 0, "US", quoteData.currency?.value || "EUR")}</div>
            </b>
          </div>

          <div className={appStyles.paymentButtonWrapper}>
            <div className={`${appStyles.buttonBlock} ${appStyles.buttonBlockAlignCenter}`}>
              <NextButton
                title={pay ? "Buy Now" : "Checkout"}
                type={pay ? "submit" : "button"}
                onClick={() => {
                  !pay && next();
                }}
              />
            </div>
            {pay && <PaymentIcons />}
            <button
              className={`${appStyles.bfLinkButton} ${appStyles.mXAuto}  ${appStyles.mY10} ${appStyles.p0} ${
                isDocsAvailable === null ? appStyles.PPTextDecorationNone : ""
              }`}
              type="button"
              onClick={() => {
                if (!isDocsAvailable) {
                  return;
                }

                window.open(isDocsAvailable, "_blank", "noopener");
              }}
            >
              Download Policy Document
            </button>
            <button
              className={`${appStyles.bfLinkButton} ${appStyles.mXAuto}  ${appStyles.mY10} ${appStyles.p0}`}
              type="button"
              onClick={() => window.open(portugueseUrlAndDocs.IPID, "_blank", "noopener")}
            >
              Single Trip IPID
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PPQuoteSummary;
